import React, { useEffect, useState, FC } from "react";
import { Pagination, Icon } from "semantic-ui-react";

interface IProps {
    totalPages: number,
    onChange: Function
    activePage: number,
   
}

const PaginationNav: FC<IProps> = ({ totalPages, onChange, activePage}) => {
    useEffect(() => {

    }, [])

    const handlePaginationChange = (e:any, activePage:any) => {
        onChange(activePage.activePage);
    }

    return (
        <Pagination style={{ marginLeft: 10 }}
            ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
            boundaryRange={1}
            activePage={activePage}
            firstItem={null}
            lastItem={null}
            prevItem={undefined}
            nextItem={undefined}
            siblingRange={1}
            totalPages={totalPages}
            onPageChange={handlePaginationChange}
        />
    );
}

export default PaginationNav;